import { useState } from "react";
import { motion } from "framer-motion";
import { Play, Sparkles, ArrowRight } from "lucide-react";
import { HERO_IMG, INTRO_VIDEO, PAYMENTS_ENABLED } from "../config";
import { VideoModal } from "./VideoModal";

export const WelcomeScreen = ({ onEnter, welcomeText, onBuy }) => {
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <div className="relative min-h-screen w-full overflow-hidden grain-overlay flex items-center justify-center px-6 py-12">
      {/* Fondo Palacio Ducal */}
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="Palacio Ducal de Lerma" className="w-full h-full object-cover" style={{ opacity: 0.55 }} />
        <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 40%, rgba(11,13,18,0.35) 0%, rgba(11,13,18,0.82) 70%, #0b0d12 100%)" }} />
      </div>

      {/* Carta central */}
      <motion.div
        initial={{ opacity: 0, y: 24, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        className="relative z-10 w-full max-w-sm glass rounded-3xl text-center"
        style={{ padding: "2.75rem 2rem 2.25rem", boxShadow: "0 20px 60px rgba(0,0,0,0.6)" }}
      >
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3, duration: 0.7 }}
          className="flex items-center justify-center gap-2 mb-6"
        >
          
          <span className="text-[11px] tracking-[0.35em] uppercase" style={{ color: "#d4af37" }}>Audioguía · Siglo de Oro</span>
        </motion.div>

        <h1 className="font-serif-display leading-none" style={{ fontSize: "clamp(3rem, 18vw, 4.5rem)", color: "#f3f4f6" }}>
          Lerma
        </h1>
        <p className="font-serif-display italic mt-2 text-2xl" style={{ color: "#d4af37" }}>La Gran Villa Ducal</p>

        <div className="my-7 mx-auto" style={{ width: 60, height: 1, background: "rgba(212,175,55,0.35)" }} />

        <p className="font-serif-display text-lg" style={{ color: "#e8e2d0", lineHeight: 1.65 }}>
          {welcomeText ||
            "Soy Catalina, vuestra guía. Pasead conmigo entre palacios y conventos del Siglo de Oro."}
        </p>

        <div className="mt-9 space-y-3">
          <button
            data-testid="welcome-video-btn"
            onClick={() => setVideoOpen(true)}
            className="w-full rounded-full py-3.5 flex items-center justify-center gap-2 text-sm transition-all duration-300"
            style={{ background: "rgba(212,175,55,0.10)", border: "1px solid rgba(212,175,55,0.3)", color: "#f0c94a" }}
          >
            <Play size={16} /> Ver presentación gratis
          </button>

          <button data-testid="welcome-enter-btn" onClick={onEnter} className="btn-gold w-full rounded-full py-4 text-base flex items-center justify-center gap-2">
            Comenzar la visita <ArrowRight size={17} />
          </button>
        </div>
      </motion.div>

      <VideoModal open={videoOpen} src={INTRO_VIDEO} title="Conjunto Histórico de Lerma" onClose={() => setVideoOpen(false)} />
    </div>
  );
};
